export const appRoutes = {
  home: '/',
  vault: '/vault',
  autoLockPlanner: '/auto-planner',
  manualLockPlanner: '/manual-planner',
  viewPassword: '/view-password/:lockId',
  unlockLock: '/unlock/:lockId',
  howItWorks: '/how-it-works',
  passwordGenerator: '/password-generator',
  contact: '/contact',
  privacyPolicy: '/privacy-policy',
  termsOfService: '/terms-of-service',
  notFound: '/*'
} as const
